/* ============================================================================
   Subtle Energies — Skincare Quiz landing page
   Production script for Shopify.

   Logo, credit heading and concierge copy come from the section settings via
   data attributes / the #se-concierge-src template — edit them in the theme
   editor, not here. Product and persona copy is edited below (search EDIT).

   DATA (updated Sep 2026 — supersedes the earlier email-only rule):
   Klaviyo receives email + consent via its own embedded form. On form submit,
   an identify call also attaches the quiz answers and the chosen persona to
   that profile as custom properties: skin_persona, skin_feel, primary_need,
   sensitivity, stress, energy. There is no backend and no API key; the answers
   sit in this closure until the form is submitted, and are discarded if it is
   not. Once submitted they persist on the Klaviyo profile indefinitely — the
   browser-side copy being transient does not make the stored copy transient.

   The persona drives conditional blocks in the follow-up email. Product keys
   are deliberately NOT stored on the profile — they would go stale whenever an
   assortment changes here. Condition on skin_persona instead.

   Note this reverses the earlier decision that answers were never sent. Skin
   concerns and sensitivity are personal information, so the privacy policy and
   the on-page wording must cover what is collected. Do not remove or extend the
   identify call without a client decision.
   ========================================================================== */
(function(){
  var root = document.getElementById('se-quiz');
  if (!root) return;
  var stage = document.getElementById('se-stage');
  var holder = document.getElementById('se-offer-holder');
  var answers = {};
  var step = 0;
  var pendingProfile = null;
  var KLAVIYO_FORM_ID = root.getAttribute('data-klaviyo-form-id') || '';

  var LOGO = root.getAttribute('data-logo') ||
    'https://cdn.shopify.com/s/files/1/0024/2289/8735/files/SE_Logo_0836d1bb-1f62-4eb6-bbb6-97cd6e640019.png?v=1787650058';

  var CREDIT_HEADING = root.getAttribute('data-credit-heading') ||
    'A $20 credit toward your new Subtle Energies staples';

  var conciergeSrc = document.getElementById('se-concierge-src');
  var CONCIERGE = (conciergeSrc && conciergeSrc.innerHTML.replace(/\s/g, '') !== '') ? conciergeSrc.innerHTML :
    '<p>If you would like to discuss your skin needs or find out whether a product is right for you, our skincare specialists are here. Email <a href="mailto:concierge@subtleenergies.com.au">concierge@subtleenergies.com.au</a> with your availability for a complimentary 15 minute consultation.</p>';

  /* ---------------- QUESTIONS ---------------- */
  var QUESTIONS = [
    { key:'skin_feel', prompt:'What is your skin like most days?', options:[
      {label:'Shiny with big pores or congested', value:'congested'},
      {label:'Dry, tight or flaky', value:'dry'},
      {label:'Balanced', value:'balanced'}
    ]},
    { key:'primary_need', prompt:'What is your main skin concern right now?', options:[
      {label:'Anti-ageing and soften fine wrinkles', value:'ageing'},
      {label:'Oil control or acne treatment', value:'oil'},
      {label:'Maintain my natural glow and radiance', value:'glow'}
    ]},
    { key:'sensitivity', prompt:'Do you have sensitive skin?', options:[
      {label:'No, my skin is not sensitive', value:'none'},
      {label:'A little, occasionally a little redness and flushing', value:'little'},
      {label:'Yes, my sskin is sensitive and easily irritated ', value:'high'}
    ]},
    { key:'stress', prompt:'How would you describe your stress levels?', options:[
      {label:'Low', value:'low'},
      {label:'Medium', value:'medium'},
      {label:'High', value:'high'}
    ]},
    { key:'energy', prompt:'How is your circulation and energy through the day?', options:[
      {label:'Not great', value:'low'},
      {label:'Medium', value:'medium'},
      {label:'Great', value:'great'}
    ]}
  ];

  /* ---------------- PRODUCTS ----------------
     EDIT here to change wording, links or images.
     togoUrl and togoImg only exist where a travel size is sold.
  ------------------------------------------- */
  var P = {
    wkCleanser:{
      name:'Wild Kashmir Purifying Gel Cleanser',
      copy:'A sulphate free cleanser that removes impurities and sebaceous buildup while retaining the skin’s natural moisture levels.',
      url:'https://www.subtleenergies.com.au/collections/wild-kashmir-purifying-range/products/wild-kashmir-purifying-cleansing-gel-125ml?variant=31767799791663',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_WILD-KASHMIR-CLEANSER_81_Shopify_1200x.jpg?v=1705465305'
    },
    wkToner:{
      name:'Wild Kashmir Purifying Toner',
      copy:'A gentle yet effective, alcohol free toner, perfect for oily, combination and acne prone skin types.',
      url:'https://www.subtleenergies.com.au/collections/wild-kashmir-purifying-range/products/wild-kashmir-purifying-toner-125ml',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_WILD-KASHMIR-TONER_128_Shopify_1200x.jpg?v=1705466053'
    },
    wkEmulsion:{
      name:'Wild Kashmir Purifying Emulsion',
      copy:'A lightweight, moisturising lotion with Wild Turmeric and rare Lavender. Ideal for oily, combination and acne prone skin.',
      url:'https://www.subtleenergies.com.au/collections/wild-kashmir-purifying-range/products/wild-kashmir-purifying-emulsion-50ml',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_WILD-KASHMIR-EMULSION_191_Shopify_1200x.jpg?v=1705467621'
    },
    pomegranate:{
      name:'Pomegranate Enzyme Mask',
      copy:'An advanced exfoliating treatment mask using a phyto-active complex of activated Pomegranate enzymes and natural AHAs. Use once or twice a week.',
      url:'https://www.subtleenergies.com.au/products/pomegranate-enzyme-mask',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE-POMEGRANITE-MASK_069_Shopify_1200x.jpg?v=1705468087'
    },
    neemCleanser:{
      name:'Gentle Neem Essential Gel Cleanser',
      copy:'A sulphate free, foaming cleanser that naturally removes excess oil and congestion.',
      url:'https://www.subtleenergies.com.au/products/gentle-neem-daily-cleansing-gel-125ml',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_NEEM-GEL-CLEANSER_33_Shopify_1200x.jpg?v=1705486403'
    },
    seCleanser:{
      name:'Soothe & Enrich Cream Cleanser',
      copy:'A gentle, calming and hydrating sulphate free cream cleanser that effectively removes impurities and pollutants.',
      url:'https://www.subtleenergies.com.au/collections/soothe-and-enrich-range/products/soothe-and-enrich-cleansing-cream-125ml?variant=31767784521775',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_SOOTHE-ENRICH-CREAM-CLEASER_46_Shopify_1200x.jpg?v=1705464114'
    },
    seToning:{
      name:'Soothe & Enrich Toning Complex',
      copy:'Cool, hydrate and tone with a unique blend of rare floral waters. Spray throughout the day, and use as an after sun mist.',
      url:'https://www.subtleenergies.com.au/collections/soothe-and-enrich-range/products/soothe-and-enrich-hydrosol-complex-125ml',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_SMOOTH-HYDROSOLTONNING-COMPLEX_139_Shopify_1200x.jpg?v=1705465944'
    },
    mmha:{
      name:'Multi-Molecular Hyaluronic Acid',
      copy:'A revolutionary, multi layered hydration technology. Instant visible results and long term hydration at the skin’s cellular layers.',
      url:'https://www.subtleenergies.com.au/products/multi-molecular-hyaluronic-acid',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_MULTI-MOLECULAR-HYLO-ACID_355_Shopify_1200x.jpg?v=1717487238'
    },
    seSerum:{
      name:'Soothe & Enrich Intensive Serum',
      copy:'Rich in vitamins, advanced antioxidants and essential fatty acids, to help reduce the visible signs of ageing.',
      url:'https://www.subtleenergies.com.au/collections/soothe-and-enrich-range/products/soothe-and-enrich-intensive-serum',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_SOOTHE-_-ENRICH-SERUM_337_Shopify_1200x.jpg?v=1705466967'
    },
    seCream:{
      name:'Soothe & Enrich Intensive Cream',
      copy:'A blend of ancient active ingredients, known for their collagen boosting properties and high antioxidant activity, to help safeguard skin against free radical damage.',
      url:'https://www.subtleenergies.com.au/collections/soothe-and-enrich-range/products/soothe-and-enrich-intensive-cream-50ml',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_SOOTHE-_-ENRICH-INTENSIVE-CREAM_177_Shopify_1200x.jpg?v=1705467436'
    },
    sootheMask:{
      name:'Soothe Pure Plant Hydrating Mask',
      copy:'Instant moisture replenishment for your skin. Cools and diffuses redness while providing deep hydration. Ideal after sun. Use once or twice a week.',
      url:'https://www.subtleenergies.com.au/collections/soothe-and-enrich-range/products/soothe-and-enrich-hydrating-mask-50ml',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_SOOTH-PURE-PLANT-HYDRTING-MASK_17_Shopify_2048x.jpg?v=1705468489'
    },
    juhi:{
      name:'Juhi Rejuvenating Milk Cleanser',
      copy:'A gentle, sulphate free milk cleanser enriched with Kewda, Sandalwood and a rare Jasmine known as Juhi.',
      url:'https://www.subtleenergies.com.au/collections/rejuvenate-restore-range/products/juhi-replenishing-milk-cleanser?variant=31767773839407',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_JUNI-MILK-CLEANSER_68_Shopify_1200x.jpg?v=1705464008',
      togoUrl:'https://www.subtleenergies.com.au/collections/rejuvenate-restore-range/products/juhi-replenishing-milk-cleanser?variant=48112840671446',
      togoImg:'https://www.subtleenergies.com.au/cdn/shop/files/JUHIMILK106_1200x.jpg?v=1787536451'
    },
    rose:{
      name:'Pure Rose Hydrosol',
      copy:'Distilled from a rare, high altitude Rose. A hydrating toner with anti-inflammatory properties to soothe skin, calm irritation and reduce redness.',
      url:'https://www.subtleenergies.com.au/collections/rejuvenate-restore-range/products/pure-rose-hydrosol-125ml',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_PURE-ROSE-HYDROSOL_93_Shopify_1200x.jpg?v=1705465731',
      togoUrl:'https://www.subtleenergies.com.au/collections/rejuvenate-restore-range/products/pure-rose-hydrosol-125ml?variant=46286041153750',
      togoImg:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_PURE-ROSE-HYDRSOL_319_Shopify_1200x.jpg?v=1705466181'
    },
    collagen:{
      name:'Vegan Collagen Serum',
      copy:'Plumps the skin and targets fine lines and deep set wrinkles, using biotechnology that mimics human collagen, animal free.',
      url:'https://www.subtleenergies.com.au/collections/for-the-face/products/vegan-collagen-serum',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_VEGAN-COLLAGEN-SERUM_345_Shopify_1200x.jpg?v=1717565298'
    },
    facialBlend:{
      name:'The Facial Blend',
      copy:'A cell renewing serum with potent anti-ageing actives that restore a youthful appearance to the skin. It is also one of the founder’s most loved formulations, stemming from her clinical work in the 1990s supporting clients through anxiety, emotional imbalance and sleeplessness.',
      /* Used when stress is medium or high. */
      copyStress:'A cell renewing serum with potent anti-ageing actives. It is also one of the founder’s most loved formulations, stemming from her clinical work in the 1990s supporting clients through anxiety, emotional imbalance and sleeplessness. Particularly good in the evening, when the mind is winding down.',
      url:'https://www.subtleenergies.com.au/collections/rejuvenate-restore-range/products/facial-blend-30ml-1?variant=31767808671791',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_THE-FACIAL-BLEND_342_Shopify_1200x.jpg?v=1705630351',
      togoUrl:'https://www.subtleenergies.com.au/collections/rejuvenate-restore-range/products/facial-blend-30ml-1?variant=46285944848598',
      togoImg:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_THE-FACIAL-BLEND_68_Shopify_d93406c9-ba8a-48fa-a19d-5bbb8e43d6e5_1200x.jpg?v=1730776334'
    },
    mogra:{
      name:'Mogra Rejuvenating Gold Cream',
      copy:'A restorative moisturiser with potent anti-ageing actives. Mogra smooths fine lines, Himalayan Rose hydrates and 24K Gold Leaf delivers collagen support.',
      url:'https://www.subtleenergies.com.au/collections/rejuvenate-restore-range/products/mogra-rejuvenating-gold-cream?variant=31767783243823',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_MOGRA-GOLD-CREAM_005_1200x.jpg?v=1705487380',
      togoUrl:'https://www.subtleenergies.com.au/collections/rejuvenate-restore-range/products/mogra-rejuvenating-gold-cream?variant=46285990691030',
      togoImg:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_GOLD-CREME_212_edited-10ml_e4fa174e-f3c2-4b75-b0a1-74d5eb5131c1_1200x.jpg?v=1730778379'
    },
    gulHeena:{
      name:'Gul Heena Essential Moisturiser',
      copy:'A gentle and balancing medium weight moisturiser that nourishes and protects, gives vitality to skin, reducing the appearance of premature ageing by firming and protecting skin.',
      url:'https://www.subtleenergies.com.au/collections/daily-skincare-range/products/gul-heena-daily-moisturiser-50ml',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_GUL-HEENA-MOISTURUSER_183_Shopify_f664beee-52a9-4511-ad20-89a46b70a931_1200x.jpg?v=1758231560'
    },

    /* ---- Rest and stress ---- */
    patches:{
      name:'Blissful Sleep Inhalation Patches',
      copy:'As you wind down, let the gradual release of dreamy, exotic oils soothe your senses and calm your mind.',
      url:'https://www.subtleenergies.com.au/products/blissful-inhalation-patches',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_BLISSFUL-SLEEP-INHALATION-PATCH_M_2161f8b3-1f17-4770-91a0-3e2573a75b78_1200x.jpg?v=1720052852'
    },
    nasya:{
      name:'Sleep Easy Nasya Oil',
      copy:'With over 20 herbs infused in Black Seed Sesame, known to assist with sleep, sinus congestion, snoring and calming the senses.',
      url:'https://www.subtleenergies.com.au/products/sleep-easy-nasya-oil-15ml',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE-SLEEP-EASY-NASYA-OIL_63_Shopify_1200x.jpg?v=1705471386'
    },
    blissBlend:{
      name:'Blissful Sleep Massage Blend',
      copy:'After bathing, embrace relaxation by applying this blend all over the body. Mogra, Kashmir Lavender, Kewda and Jatamansi.',
      url:'https://www.subtleenergies.com.au/products/bliss-blend-10ml?variant=31767828332591',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_BLISFUL-SLEEP-MASSAGE-BLEND__361_1200x.jpg?v=1705471597'
    },

    /* ---- Energy and circulation ---- */
    auraMist:{
      name:'Boost your energy with the Aura Protection Body Mist',
      copy:'For grounding and clarity throughout the day, Mist the aromatics of Tulasi, Saffron and Rhu Khus all around around you, inhale gently and pause.',
      url:'https://www.subtleenergies.com.au/products/aura-protection-body-mist',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_AURA-PROTECTION-MIST_170_Shopify_600x.jpg?v=1705477526'
    },
    rasayanaBlend:{
      name:'Rasayana Detox Body Blend',
      copy:'Use this invigorating blend post-shower, massage all over your body from feet towards the heart, to boost your energy and circulation for the day ahead.',
      url:'https://www.subtleenergies.com.au/products/rasayana-detox-body-blend-50ml',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_RASAYANA-BODY-BLEND_369_Shopify_600x.jpg?v=1705473325'
    },
    rasayanaScrub:{
      name:'Rasayana Detox Body Scrub',
      copy:'Detoxify  and improve circulation with this walnut and cinnamon scrub. Buff away rough skin, impurities and de-congest blocked pores. Twice a week',
      url:'https://www.subtleenergies.com.au/collections/body-exfoliant/products/rasayana-detox-body-scrub-250ml',
      img:'https://www.subtleenergies.com.au/cdn/shop/files/2023-SE_RASAYANA-BODY-SCRUB_299_Shopify_600x.jpg?v=1705476426'
    }
  };

  /* ---------------- PERSONAS ---------------- */
  var PERSONAS = {
    congested:{
      name:'The Congested',
      intro:'If your skin runs shiny or congested, it responds well to steady, balancing care rather than anything harsh. The products below are selected for you for their ability to balance overactive oil flow and breakouts, and heal minor blemishes, while staying gentle on the skin.',
      products:['wkCleanser','wkToner','wkEmulsion','pomegranate']
    },
    reactiveCongested:{
      name:'The Reactive Congested',
      intro:'Reactive skin that reddens or flushes easily responds well to soothing, calming care rather than anything that might unsettle it. The products below are selected for you for their ability to defuse the heat and inflammation in the skin, while providing the age defying benefits of collagen stimulation and deep hydration.',
      products:['neemCleanser','seToning','seSerum','wkEmulsion','pomegranate']
    },
    depleted:{
      name:'The Depleted',
      intro:'When skin feels depleted or is losing its glow, it responds well to nourishing, cell renewing care. The products below are selected for you for their cell renewing and collagen supporting actives, chosen to restore a radiant glow and deep nourishment.',
      products:['juhi','rose','mmha','collagen','facialBlend','mogra','pomegranate','sootheMask']
    },
    reactiveDepleted:{
      name:'The Reactive Depleted',
      intro:'When skin feels depleted or is losing its glow, it responds well to nourishing, cell renewing care. The products below are selected for you for their ability to defuse the heat and inflammation in the skin, while providing the age defying benefits of collagen stimulation and deep hydration.',
      products:['seCleanser','seToning','mmha','collagen','seSerum','seCream','sootheMask']
    },
    maintainer:{
      name:'The Maintainer',
      intro:'When skin is balanced, the work is in keeping it that way. The products below are selected for you to hydrate, nourish and protect, holding the radiance your skin already has.',
      products:['neemCleanser','rose','mmha','facialBlend','gulHeena']
    },
    reactiveMaintainer:{
      name:'The Reactive Maintainer',
      intro:'Balanced skin that reddens or flushes easily responds well to soothing, calming care rather than anything that might unsettle it. The products below are selected for you to hydrate and calm, holding your natural radiance without unsettling the skin.',
      products:['seCleanser','seToning','collagen','seSerum','gulHeena']
    }
  };

  /* Q1 adds a note when it sits at odds with the concern. */
  var SKIN_NOTE = {
    'dry|oil':'You noted dry, tight skin alongside oil control. This is usually dehydrated skin overproducing oil, so the aim is hydration rather than stripping.',
    'congested|ageing':'You noted congestion alongside fine lines, so the routine below stays light in texture while still working on renewal.',
    'balanced|oil':'Your skin reads balanced overall, so the routine below manages oil without overcorrecting.',
    'congested|glow':'You noted congestion alongside radiance, so clarity comes first and glow follows from it.',
    'dry|glow':'You noted dryness alongside radiance. Moisture the skin can hold is what brings the glow back.',
    'balanced|ageing':'Your skin reads balanced, so the routine below focuses on renewal rather than repair.'
  };

  /* ---------------- ROUTING ----------------
     The concern chooses the family. Sensitivity chooses the variant.
     This covers every combination, not only the six listed.
  ------------------------------------------- */
  function choosePersona(a){
    if (a.primary_need === 'oil'){
      return a.sensitivity === 'none' ? 'congested' : 'reactiveCongested';
    }
    if (a.primary_need === 'ageing'){
      return a.sensitivity === 'high' ? 'reactiveDepleted' : 'depleted';
    }
    return a.sensitivity === 'high' ? 'reactiveMaintainer' : 'maintainer';
  }

  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;'); }

  function productRow(key, index, stressed){
    var p = P[key];
    var copy = (stressed && p.copyStress) ? p.copyStress : p.copy;
    var tag = (stressed && p.copyStress) ? '<div class="p-tag">Chosen for rest as well as skin</div>' : '';
    var thumb = p.img
      ? '<img src="'+p.img+'" alt="'+esc(p.name)+'" loading="lazy">'
      : '';
    return '<div class="p-row">'+
      '<a class="p-thumb" href="'+p.url+'" target="_blank" rel="noopener">'+thumb+'</a>'+
      '<div class="p-body">'+
        tag+
        '<p class="p-name">'+index+'. '+esc(p.name)+'</p>'+
        '<p class="p-copy">'+esc(copy)+'</p>'+
        '<a class="p-btn" href="'+p.url+'" target="_blank" rel="noopener">Add it to your ritual</a>'+
      '</div>'+
    '</div>';
  }

  function section(heading, intro, keys){
    var i = 0;
    var rows = keys.map(function(k){ i++; return productRow(k, i, false); }).join('');
    return '<div class="r-rule"></div>'+
      '<h2 class="r-sec-h">'+heading+'</h2>'+
      '<p class="r-sec-p">'+intro+'</p>'+
      rows;
  }

  /* ---------------- SCREENS ---------------- */
  function question(){
    var q = QUESTIONS[step];
    var marks = QUESTIONS.map(function(_,i){
      return '<span class="q-mark'+(i<=step?' on':'')+'"></span>';
    }).join('');
    var opts = q.options.map(function(o){
      return '<button class="q-opt" data-value="'+o.value+'">'+o.label+'</button>';
    }).join('');

    stage.innerHTML =
      '<div class="q-screen fade">'+
        '<div class="q-top"><span class="q-count">0'+(step+1)+' OF 0'+QUESTIONS.length+'</span></div>'+
        '<div class="q-marks">'+marks+'</div>'+
        '<div class="q-mid">'+
          '<h1 class="q-title">'+q.prompt+'</h1>'+
          '<div class="q-opts">'+opts+'</div>'+
          (step>0 ? '<button class="q-back">Back</button>' : '')+
        '</div>'+
        '<div class="q-foot">'+
          '<img class="logo" src="'+LOGO+'" alt="Subtle Energies">'+
          '<p class="se-tag">Created with Intent, <em>Made to Empower</em></p>'+
        '</div>'+
      '</div>';

    Array.prototype.forEach.call(stage.querySelectorAll('.q-opt'), function(b){
      b.onclick = function(){
        answers[q.key] = b.getAttribute('data-value');
        step++;
        if (step < QUESTIONS.length){ question(); } else { result(); }
        window.scrollTo(0,0);
      };
    });
    var back = stage.querySelector('.q-back');
    if (back) back.onclick = function(){ step--; question(); window.scrollTo(0,0); };
  }

  function result(){
    var key = choosePersona(answers);
    var persona = PERSONAS[key];
    var stressed = (answers.stress === 'medium' || answers.stress === 'high');
    var note = SKIN_NOTE[answers.skin_feel + '|' + answers.primary_need] || '';

    /* Main routine */
    var n = 0;
    var rows = persona.products.map(function(k){ n++; return productRow(k, n, stressed); }).join('');

    /* Rest, only when stress is medium or high */
    var restHtml = '';
    if (stressed){
      restHtml = section(
        'Rest Shows On Your Skin',
        'When we are rested from within, it shows on the skin. A good sleep is the most profound beauty ritual we possess, which is why we have included a few favourites to help you wind down and rest well.',
        ['patches','nasya','blissBlend']
      );
    }

    /* Energy, from question five */
    var energyHtml = '';
    if (answers.energy === 'low'){
      energyHtml = section(
        'Boosting Your Energy',
        'When circulation is sluggish, the whole body feels it. These few favourites are chosen to invigorate, ground and bring energy back to the day.',
        ['auraMist','rasayanaBlend','rasayanaScrub']
      );
    } else if (answers.energy === 'medium'){
      energyHtml = section(
        'Boosting Your Energy',
        'A little support goes a long way. These two favourites are chosen to invigorate, ground and bring energy back to the day.',
        ['auraMist','rasayanaBlend']
      );
    }

    /* Travel sizes, only products in this routine that have a travel size */
    var togoKeys = persona.products.filter(function(k){ return P[k].togoUrl; });
    var togoHtml = '';
    if (togoKeys.length){
      var tiles = togoKeys.map(function(k){
        var p = P[k];
        return '<a class="togo" href="'+p.togoUrl+'" target="_blank" rel="noopener">'+
          '<img src="'+p.togoImg+'" alt="'+esc(p.name)+' travel size" loading="lazy">'+
          '<span class="togo-ov"><span class="togo-name">'+esc(p.name)+'</span>'+
          '<span class="togo-shop">Shop</span></span></a>';
      }).join('');
      togoHtml =
        '<div class="r-rule"></div>'+
        '<h2 class="r-sec-h">Skincare on the Go</h2>'+
        '<p class="r-sec-p">Your routine in travel size, so it comes with you wherever you go.</p>'+
        '<div class="togo-grid">'+tiles+'</div>';
    }

    stage.innerHTML =
      '<div class="r-wrap fade">'+
        '<img class="r-logo" src="'+LOGO+'" alt="Subtle Energies">'+
        '<div class="r-rule"></div>'+
        '<p class="r-intro">'+esc(persona.intro)+'</p>'+
        (note ? '<p class="r-note">'+esc(note)+'</p>' : '')+
        '<div class="r-rule"></div>'+
        '<div class="r-offer">'+
          '<h2 class="r-offer-h">'+CREDIT_HEADING+'</h2>'+
          '<div class="r-form" id="se-form-slot"></div>'+
        '</div>'+
        '<div class="r-rule"></div>'+
        rows+
        restHtml+
        energyHtml+
        togoHtml+
        '<div class="r-concierge">'+CONCIERGE+'</div>'+
        '<div class="r-foot">'+
          '<img class="logo" src="'+LOGO+'" alt="Subtle Energies">'+
          '<p class="se-tag">Created with Intent, <em>Made to Empower</em></p>'+
        '</div>'+
        '<button class="r-again">Begin again</button>'+
      '</div>';

       /* Move the live Klaviyo form into the offer slot. */
    var slot = document.getElementById('se-form-slot');
    holder.style.display = 'block';
    slot.appendChild(holder);

     stage.querySelector('.r-again').onclick = function(){
      document.body.appendChild(holder);
      holder.style.display = 'none';
      answers = {}; step = 0; pendingProfile = null; question(); window.scrollTo(0,0);
    };

    /* Attach the persona to the profile when the email form is submitted.
       Held in this closure rather than on window: every third-party app on
       the page can read window.*, and these answers should not be legible
       to the chat, review and popup scripts running alongside us. */
    pendingProfile = {
      skin_persona: key,
      skin_feel: answers.skin_feel,
      primary_need: answers.primary_need,
      sensitivity: answers.sensitivity,
      stress: answers.stress,
      energy: answers.energy
    };
  }

  window.addEventListener('klaviyoForms', function(e){
    if (!e.detail || e.detail.type !== 'submit' || !pendingProfile) return;

    /* Only this quiz's own form. Without the check, completing the quiz and
       then submitting an unrelated Klaviyo popup would attach the quiz
       answers to that submission too. */
    if (KLAVIYO_FORM_ID && e.detail.formId && e.detail.formId !== KLAVIYO_FORM_ID) return;

    var data = {};
    for (var k in pendingProfile){ data[k] = pendingProfile[k]; }

    var email = (e.detail.metaData && e.detail.metaData.$email) || '';
    if (!email){
      var field = document.querySelector('#se-quiz input[type="email"]');
      if (field) email = field.value;
    }
    if (email){ data.$email = email; }

    var _learnq = window._learnq || (window._learnq = []);
    _learnq.push(['identify', data]);
  });

  question();
})();